/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptDayOption } from '../models/V3StackAdaptDayOption';
import { HttpFile } from '../http/http';

/**
* Configuration for setting time slots and budget on specific days of the week
*/
export class V3StackAdaptDayOptions {
    'monday'?: V3StackAdaptDayOption;
    'tuesday'?: V3StackAdaptDayOption;
    'wednesday'?: V3StackAdaptDayOption;
    'thursday'?: V3StackAdaptDayOption;
    'friday'?: V3StackAdaptDayOption;
    'saturday'?: V3StackAdaptDayOption;
    'sunday'?: V3StackAdaptDayOption;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "monday",
            "baseName": "monday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        },
        {
            "name": "tuesday",
            "baseName": "tuesday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        },
        {
            "name": "wednesday",
            "baseName": "wednesday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        },
        {
            "name": "thursday",
            "baseName": "thursday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        },
        {
            "name": "friday",
            "baseName": "friday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        },
        {
            "name": "saturday",
            "baseName": "saturday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        },
        {
            "name": "sunday",
            "baseName": "sunday",
            "type": "V3StackAdaptDayOption",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptDayOptions.attributeTypeMap;
    }

    public constructor() {
    }
}

